import React from 'react';
import OverviewCard from '../../components/Dashboard/OverviewCard/OverviewCard';
import Calendar from '../../components/Dashboard/Calendar/Calendar';
import TelehealthCard from '../../components/Dashboard/TelehealthCard/TelehealthCard';
import MessagingCard from '../../components/Dashboard/MessagingCard/MessagingCard';
import DocumentsCard from '../../components/Dashboard/DocumentsCard/DocumentsCard';
import BillingCard from '../../components/Dashboard/BillingCard/BillingCard';
import AnalyticsCard from '../../components/Dashboard/AnalyticsCard/AnalyticsCard';
import Settings from '../Settings/Settings';
import './AdminDashboard.css';

const Dashboard = ({ currentPage }) => {
  const pageToTabMap = {
    dashboard: 'overview',
    clients: 'appointments',
    analytics: 'analytics',
    docs: 'documents',
    settings: 'settings'
  };

  const mappedTab = pageToTabMap[currentPage];
  const visibleTab = mappedTab || 'overview';

  const appointments = [
    {
      patientName: 'John Smith',
      service: 'Annual Checkup',
      dateTime: new Date(new Date().setHours(14, 30, 0, 0)), // Today at 2:30 PM
      status: 'Confirmed'
    },
    {
      patientName: 'Sarah Johnson',
      service: 'Follow-up Consultation',
      dateTime: (() => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(10, 0, 0, 0);
        return tomorrow;
      })(), // Tomorrow at 10:00 AM
      status: 'Confirmed'
    },
    {
      patientName: 'Michael Davis',
      service: 'Physical Therapy',
      dateTime: (() => {
        const friday = new Date();
        friday.setDate(friday.getDate() + 3);
        friday.setHours(15, 45, 0, 0);
        return friday;
      })(), // Friday at 3:45 PM
      status: 'Pending'
    },
    {
      patientName: 'Emma Wilson',
      service: 'Routine Screening',
      dateTime: (() => {
        const nextMonday = new Date();
        nextMonday.setDate(nextMonday.getDate() + 7);
        nextMonday.setHours(9, 15, 0, 0);
        return nextMonday;
      })(), // Next Monday at 9:15 AM
      status: 'Confirmed'
    },
    {
      patientName: 'David Brown',
      service: 'Dental Cleaning',
      dateTime: (() => {
        const dayAfterTomorrow = new Date();
        dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);
        dayAfterTomorrow.setHours(11, 0, 0, 0);
        return dayAfterTomorrow;
      })(), // Day after tomorrow at 11:00 AM
      status: 'Confirmed'
    },
    {
      patientName: 'Lisa Garcia',
      service: 'Eye Exam',
      dateTime: (() => {
        const saturday = new Date();
        saturday.setDate(saturday.getDate() + 5);
        saturday.setHours(13, 30, 0, 0);
        return saturday;
      })(), // Saturday at 1:30 PM
      status: 'Pending'
    }
  ];

  const invoices = [
    {
      invoiceNumber: 'Invoice #INV-001',
      patientService: 'John Smith - Annual Checkup',
      dueDate: 'Dec 15, 2024',
      amount: '350.00',
      status: 'Paid'
    },
    {
      invoiceNumber: 'Invoice #INV-002',
      patientService: 'Sarah Johnson - Consultation',
      dueDate: 'Dec 20, 2024',
      amount: '220.00',
      status: 'Pending'
    },
    {
      invoiceNumber: 'Invoice #INV-003',
      patientService: 'Michael Davis - Physical Therapy',
      dueDate: 'Nov 30, 2024',
      amount: '180.00',
      status: 'Overdue'
    }
  ];

  return (
    <div className="dashboard">
      <div className="dashboard-content">
        {visibleTab === 'overview' && (
          <OverviewCard />
        )}

        {visibleTab === 'appointments' && (
          <Calendar appointments={appointments} />
        )}

        {visibleTab === 'telehealth' && (
          <TelehealthCard />
        )}

        {visibleTab === 'messaging' && (
          <MessagingCard />
        )}

        {visibleTab === 'documents' && (
          <DocumentsCard />
        )}

        {visibleTab === 'billing' && (
          <BillingCard />
        )}

        {visibleTab === 'analytics' && (
          <AnalyticsCard />
        )}

        {visibleTab === 'settings' && (
          <Settings />
        )}
      </div>
    </div>
  );
};

export default Dashboard;
